import "react-day-picker/lib/style.css";
import DayPickerInput from "react-day-picker/DayPickerInput";
import React from 'react';
import MomentLocaleUtils from 'react-day-picker/moment';
import './day-picker.scss';

interface CustomDayPickerInputProps {
	onDayChange: (day: Date) => void,
    value: Date,
    disabled?: boolean,
    onBlur?: (e: React.FocusEvent<HTMLDivElement>) => void;
}

function CustomDayPickerInput(props: CustomDayPickerInputProps): JSX.Element {
    const {
		onDayChange,
        value,
        onBlur,
        disabled,
	} = props;
    
    return <DayPickerInput
        onDayChange={onDayChange}
        format="LL"
        inputProps={{ disabled: disabled }}
        value={value}
        onBlur={onBlur}
        formatDate={MomentLocaleUtils.formatDate}
        parseDate={MomentLocaleUtils.parseDate}
        placeholder={`${MomentLocaleUtils.formatDate(new Date(), 'LL', 'ru')}`}
        dayPickerProps={{
            locale: 'ru',
            localeUtils: MomentLocaleUtils,
        }}
    />
}

export { CustomDayPickerInput as DayPickerInput  };